/**
 * t364u: the most one uploaded file may be, shared by the API (which checks the real size that landed in storage) and
 * the web, phone web and iOS app (which check before sending any bytes, so nobody waits for a doomed upload).
 *
 * 50 MB (binary megabytes, 52,428,800 bytes), the same as the Storage buckets' file_size_limit. Files already stored
 * that are bigger stay as they are; the limit only applies to new uploads.
 */
import { UPLOAD_REFUSED, uploadRefused } from './uploadTypes';

export const MAX_UPLOAD_MB = 50;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

/** The one sentence every front end (and the API) shows when a file is too big. */
export const UPLOAD_TOO_BIG = `That file is over ${MAX_UPLOAD_MB} MB. The most you can upload is ${MAX_UPLOAD_MB} MB.`;

/** True when a file of this many bytes is over the limit. An unknown size (0, null) is left to the server to check. */
export const uploadTooBig = (sizeBytes: number | null | undefined) => typeof sizeBytes === 'number' && sizeBytes > MAX_UPLOAD_BYTES;

/**
 * What the front ends check before uploading a picked file: its type (UPLOAD_REFUSED) and its size (UPLOAD_TOO_BIG).
 * Null when it can go. The API checks both again on what really lands in storage.
 */
export function uploadProblem(file: { name?: string | null; type?: string | null; size?: number | null }): string | null {
  if (uploadRefused(file.name, file.type)) return UPLOAD_REFUSED;
  if (uploadTooBig(file.size)) return UPLOAD_TOO_BIG;
  return null;
}

/**
 * A toast for a failed upload: the refusal sentences stand on their own (the same words in every app); anything else
 * gets the screen's lead, e.g. "Upload failed: …".
 */
export const uploadFailureText = (message: string, lead: string) =>
  message === UPLOAD_TOO_BIG || message === UPLOAD_REFUSED ? message : `${lead}: ${message}`;
